function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'date-picker';

/**
 * This is the component description.
 */
const DatePickerWrapper = ({
  id,
  className: userClassName,
  style,
  mode,
  selected,
  setSelection,
  fromMonth,
  toDate,
  customFooter,
  timeFrom,
  setTimeFrom,
  timeTo,
  setTimeTo,
  dateFormat,
  showDebugger,
  ...otherProps
}) => {
  const convertFooterText = selection => {
    if (mode === 'single') {
      return format(selection, dateFormat);
    }
    if (mode === 'multiple') {
      return selection.map(date => format(date, dateFormat)).join(', ');
    }
    if (mode === 'range') {
      return selection.from && selection.to ? `${format(selection.from, dateFormat)} - ${format(selection.to, dateFormat)}` : 'Please pick an additional day.';
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement(DayPicker, _extends({
    mode: mode,
    selected: selected,
    onSelect: setSelection,
    fromMonth: fromMonth,
    toDate: toDate,
    showOutsideDays: true,
    footer: customFooter || /*#__PURE__*/React.createElement("div", {
      className: "default-footer"
    }, setTimeFrom && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "time-label s-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, "C"), "\xA0 Time"), /*#__PURE__*/React.createElement("div", {
      className: `time-inputs${timeTo ? ' multiple' : ''}`
    }, /*#__PURE__*/React.createElement("input", {
      className: "s-1",
      type: "time",
      value: timeFrom,
      onChange: e => setTimeFrom(e.target.value)
    }), setTimeTo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "icon s-2"
    }, "r"), /*#__PURE__*/React.createElement("input", {
      className: "s-1",
      type: "time",
      value: timeTo,
      onChange: e => setTimeTo(e.target.value)
    })))), /*#__PURE__*/React.createElement("p", {
      className: "s-1 footer-text"
    }, selected && convertFooterText(selected)))
  }, otherProps)), showDebugger && /*#__PURE__*/React.createElement("div", {
    className: "debugger"
  }, /*#__PURE__*/React.createElement("pre", null, JSON.stringify(selected, null, 2))));
};
DatePickerWrapper.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The mode for this date picker.
   */
  mode: PropTypes.oneOf(['single', 'multiple', 'range']),
  /**
   * The current selection.
   */
  // eslint-disable-next-line react/forbid-prop-types
  selected: PropTypes.objectOf(PropTypes.any).isRequired,
  /**
   * The function to update the selection.
   */
  setSelection: PropTypes.func.isRequired,
  /**
   * The earliest month to display.
   */
  fromMonth: PropTypes.instanceOf(Date),
  /**
   * The latest month to display.
   */
  toDate: PropTypes.instanceOf(Date),
  /**
   * Custom footer component.
   */
  customFooter: PropTypes.node,
  /**
   * The start time.
   */
  timeFrom: PropTypes.string,
  /**
   * The function to update the start time.
   */
  setTimeFrom: PropTypes.func,
  /**
   * The end time.
   */
  timeTo: PropTypes.string,
  /**
   * The function to update the end time.
   */
  setTimeTo: PropTypes.func,
  /**
   * The date format.
   */
  dateFormat: PropTypes.string,
  /**
   * Show the debugger.
   */
  showDebugger: PropTypes.bool
};
DatePickerWrapper.defaultProps = {
  mode: 'single',
  dateFormat: 'PPP',
  showDebugger: false
};
export default DatePickerWrapper;